import clsx from 'clsx';

import type { BoxProps } from '../Box/Box';
import { Box } from '../Box/Box';

import { Body } from './Body/Body';
import { Cell } from './Cell/Cell';
import { Collapsible } from './Collapsible/Collapsible';
import { Discoverable } from './Discoverable/Discoverable';
import { FullRow } from './FullRow/FullRow';
import { Head } from './Head/Head';
import { Header } from './Header/Header';
import { Row } from './Row/Row';
import { Search } from './Search/Search';

import { noBorder as styles_noBorder, table } from './styles.css';

export interface Props extends Omit<BoxProps, 'cssClass'> {
  children: React.ReactNode;
  className?: string;
  noBorder?: boolean;
}

const TableComponent: React.FC<Props> = ({ children, className, noBorder, ...boxProps }) => (
  <Box
    cssClass={clsx(table, className, {
      [styles_noBorder]: noBorder,
    })}
    width="full"
    {...boxProps}
  >
    {children}
  </Box>
);

type TableWithComponents = React.FC<Props> & {
  Body: typeof Body;
  Cell: typeof Cell;
  Collapsible: typeof Collapsible;
  Discoverable: typeof Discoverable;
  FullRow: typeof FullRow;
  Head: typeof Head;
  Header: typeof Header;
  Row: typeof Row;
  Search: typeof Search;
};

const Table = TableComponent as TableWithComponents;

Table.Body = Body;
Table.Cell = Cell;
Table.Collapsible = Collapsible;
Table.Discoverable = Discoverable;
Table.FullRow = FullRow;
Table.Head = Head;
Table.Header = Header;
Table.Row = Row;
Table.Search = Search;

export { Table };
